import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Overlay from 'components/atoms/Overlay/Overlay';
import Txt from 'components/atoms/Txt/Txt';
import { ReferralsMetrics_referralsRef$key } from 'components/molecules/ReferralsMetrics/__generated__/ReferralsMetrics_referralsRef.graphql';
import { MdClose } from 'react-icons/md';
import { graphql, useFragment } from 'react-relay';
import classes from './ReferralsMetrics.module.scss';

export type Props = {
  referralsRef: ReferralsMetrics_referralsRef$key;
  onClose: () => void;
};

const ReferralMetricsFragment = graphql`
  fragment ReferralsMetrics_referralsRef on ReferralHistory {
    lifetime {
      successes
      pending
    }
  }
`;

export default function ReferralsMetrics({ referralsRef, onClose }: Props) {
  const data = useFragment(ReferralMetricsFragment, referralsRef);

  return (
    <Overlay onBackgroundInteraction={onClose}>
      <Card className={classes.container}>
        <Heading level={2} className={classes.title}>
          Referral Tracking
          <Button buttonType="text" className={classes.closeButton} onClick={onClose}>
            <MdClose width={30} height={30} />
          </Button>
        </Heading>
        <table className={classes.metrics}>
          <tbody>
            <tr>
              <td className={classes.metricDescription}>
                <Heading level={3} className={classes.metricDescriptionTitle}>
                  Successful
                </Heading>
                <Txt className={classes.metricDescriptionText} component="p">
                  A maximum of 5 successful referral rewards paid each month, any additional
                  referrals will be carried over to the next month.
                </Txt>
              </td>
              <td className={classes.metricValue}>
                <Txt className={classes.totalLabel}>Total</Txt>
                <span className={classes.number}>{data.lifetime.successes}</span>
              </td>
            </tr>
            <tr>
              <td className={classes.metricDescription}>
                <Heading level={3} className={classes.metricDescriptionTitle}>
                  Pending
                </Heading>
                <Txt className={classes.metricDescriptionText} component="p">
                  These are your referrals that have yet to complete their first 3 surveys.{' '}
                  <b>Try giving them a nudge and get them on board.</b> 😉
                </Txt>
              </td>
              <td className={classes.metricValue}>
                <Txt className={classes.totalLabel}>Total</Txt>
                <span className={classes.number}>{data.lifetime.pending}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
    </Overlay>
  );
}
